
































































































































































































































































































































































































































import { Vue, Component, Watch } from 'vue-property-decorator'
import { IUpedRes } from '@/api/files/files-updown/res'
import { getAndroidUpedList, getAndroidAppChannelList, putUpAppAndroid, putDownAppAndroid, markAppAndroid } from '@/api/files/files-updown/filesUpdown'
import { EStateColor } from '@/typings/enum'
import { Form } from 'element-ui'
import { resetObjValue2NoneString, compareDate } from '@/utils/tool'
import { getAndroidSource, getAppStatus } from '@/api/files/files-app/filesApp'
import { getChaos, getCookie, getImgURLOfBase64 } from '@/utils/fix'
// 所有渠道映射表
import { getSearchCategory } from '@/api/files/files-search/filesSearch'
import { getDownReason, getDownStatus } from '@/api/common'
import { mixins } from 'vue-class-component'
import DateOption from '@/mixins/dateOption'

@Component({
  name: 'FilesUpdownAndroidUped'
})
export default class extends mixins(DateOption) {
  // data
  private params = {
    id: '',
    name: '',
    fileBundleid: '',
    regionCode: '',
    status: '',
    updateDateStart: '',
    updateDateEnd: '',
    page: 1,
    pageCount: 20
  }
  private upParams = {
    id: '',
    channel: [],
    startDate: '',
    endDate: ''
  }
  private downParams = {
    id: '',
    channel: [],
    type: '',
    reason: '',
    detail: ''
  }
  private distributeParams = {
    id: '',
    distributeArea: []
  }
  // template data
  private sourceList: Array<ISelectItem> = []
  private options: Array<ISelectItem> = [] // 文件状态
  private downReasonList: ISelectItem[] = []
  private downStatusList: ISelectItem[] = []
  private channelList: Array<{id: string, name: string, disabled?: boolean}> = []
  private appChannelList: any[] = []
  private showFormItem: boolean = false
  private upFormVisible: boolean = false
  private downFormVisible: boolean = false
  private distributeVisible: boolean = false
  private tableData: IUpedRes[] = []
  private selectedData: IUpedRes[] = []
  private totalCount: number = 0
  private dateArray: string[] = ['', '']
  private stateColor = EStateColor

  routeQuery: IQuery = { id: 0, platform: 'android' }
  private rules: any = {
    id: [{ required: true, message: '请输入ID', trigger: 'blur' }],
    channel: [{ required: true, message: '选择语言渠道', trigger: 'change' }],
    startDate: [
      {
        required: true,
        message: '请选择开始时间',
        trigger: 'blur'
      }
    ],
    distributeArea: [{ type: 'array', required: true, message: '请至少选择一个地区', trigger: 'change' }]
  }
  private isAllDown: boolean = false
  tableLoading = false
  openWindow: any
  operate: string = ''
  tableHeight: number = 500
  // lifecycle
  created() {
    this.getTableData()
    this.getAndroidSource()
    this.getAppStatus()
    this.getAllChannel()
    this.getDownReasonList()
    this.getDownStatusList()
    // console.log(this.checkSrc('http://pics.tutuapp.com//picture/app_ios/us/2020/05/26/10/rp48ahw5ex5a.jpeg'))
    this.$nextTick(() => {
      this.setTableHeight()
      window.addEventListener('resize', this.setTableHeight)
    })
  }
  beforeDestroy() {
    window.removeEventListener('resize', this.setTableHeight)
  }
  // methods
  async getTableData() {
    this.tableLoading = true
    let res = await getAndroidUpedList(this.params)
    let dataList = res.data.dataList || []
    let buildEnv = process.env.VUE_APP_ENV || ''
    if (buildEnv !== 'env') {
      this.tableData = dataList
      this.tableLoading = false
      this.totalCount = res.data.pageInfo.totalCount
      return false
    }
    this.tableData = []
    await getChaos()
    let header = {
      abc: getCookie('abc')
    }
    this.tableLoading = false
    const cover: string = require('@/assets/images/loading.svg')
    dataList.forEach((item: any) => {
      let el = { ...item }
      el.icon = cover
      this.tableData.push(el)
    })
    this.totalCount = res.data.pageInfo.totalCount
    for (let i = 0; i < dataList.length; i++) {
      getImgURLOfBase64(dataList[i].icon, header).then(res => {
        this.tableData[i]['icon'] = res as string
      })
    }
    this.tableLoading = false
    this.totalCount = res.data.pageInfo.totalCount
  }
  async getAndroidSource() {
    let res = await getAndroidSource()
    this.sourceList = res.data.dataList
  }
  async getAppStatus() {
    let res = await getAppStatus({
      ids: '5,6'
    })
    this.options = res.data
  }
  async getAllChannel() {
    let res: any = await getSearchCategory({
      isIos: false
    })
    let list = res.data
    this.channelList = list.map((item: any) => {
      return {
        id: item.id,
        name: item.name,
        disabled: item.disabled
      }
    })
  }
  async getAndroidAppChannelList(id: number) {
    let res = await getAndroidAppChannelList({ id })
    this.appChannelList = res.data.dataList
    return res.data.dataList
  }
  async getDownReasonList() {
    let res = await getDownReason()
    this.downReasonList = res.data
  }
  async getDownStatusList() {
    let res = await getDownStatus()
    this.downStatusList = res.data
  }
  handleInput(val: string, attr: string) {
    (this.params as any)[attr] = val.replace(/[^0-9]/g, '')
  }
  async putUpAppAndroid() {
    let res: any = await putUpAppAndroid({
      ids: this.upParams.id,
      channel: this.upParams.channel.join(','),
      startDate: this.upParams.startDate,
      endDate: this.upParams.endDate
    })
    if (res.status.code === 0) {
      this['$message'].success('提交成功!')
      this.cancelUpForm()
    } else {
      this['$message'].error('提交失败!')
    }
  }
  async putDownAppAndroid() {
    let ids = this.downParams.id
    if (this.selectedData.length > 0) {
      ids = this.selectedData.map(item => item.id).toString()
    }
    let res: any = await putDownAppAndroid({
      ids,
      channel: this.downParams.channel.toString(),
      type: this.downParams.type,
      reason: this.downParams.reason,
      remark: this.downParams.detail
    })
    if (res.status.code === 0) {
      this['$message'].success('操作成功!')
      this.cancelDownForm()
      this.getTableData()
      ;(this.$refs['multiTable'] as any).clearSelection()
    } else {
      this['$message'].warning('操作失败!')
    }
  }
  async handleOperate(operate: string) {
    if (operate === 'down') {
      if (this.selectedData.length <= 0) {
        this.operate = ''
        return this.$message.warning('请选择要下架的应用')
      }
      this.downParams.id = this.selectedData.length + '个所选中的应用'
      this.downFormVisible = true
    }
    this.operate = ''
  }
  async markAppAndroid(ids: string) {
    let res: any = await markAppAndroid({ ids })
    if (res.status.code === 0) {
      this['$message'].success('已标记，前往待更新列表可查看!')
    } else {
      this['$message'].error('标记失败!')
    }
  }
  setTableHeight() {
    const filter: any = this.$refs.filter
    const filterDom: any = filter.$el
    this.tableHeight = document.body.clientHeight - 260 - filterDom.clientHeight
  }
  handleDateChange(date: string[]) {
    this.params.updateDateStart = date && date[0]
    this.params.updateDateEnd = date && date[1]
  }
  handleSearch() {
    if (this.tableLoading) { return false }
    let params:any = { ...this.params }
    for (let i in params) {
      if (typeof params[i] === 'string') {
        params[i] = params[i].trim()
      }
    }
    this.params = params
    this.params.page = 1
    this.getTableData()
  }
  handleReset() {
    resetObjValue2NoneString(this.params, ['page', 'pageCount'])
    this.dateArray = ['', '']
    this.params.page = 1
    this.getTableData()
  }
  handleSelectionChange(list: IUpedRes[]) {
    this.selectedData = list
  }
  handleSelectReverse() {
    this.selectedData = []
    let tempList: number[] = []
    let tempSelectList: number[] = []
    let indexList: number[] = []
    tempList = this.tableData.map(item => item.id)
    tempSelectList = this.selectedData.map(item => item.id)
    indexList = tempList.filter(item => !tempSelectList.includes(item))
    this.tableData.forEach(item => {
      if (indexList.includes(item.id)) this.selectedData.push(item)
    })

    // this.selectedData = this.tableData.filter(item => indexList.includes(item.id))
    if (this.selectedData.length) {
      this.selectedData.forEach(row => {
        (this.$refs['multiTable'] as any).toggleRowSelection(row)
      })
    } else {
      (this.$refs['multiTable'] as any).clearSelection()
    }
  }
  handleDistributeAll() {
    this.distributeVisible = true
    let t: number[] = []
    this.selectedData.forEach(item => {
      t.push(item.id)
    })
    this.distributeParams.id = t.join(',')
  }
  handlePutAll() {
    this.upFormVisible = true
    let t: number[] = []
    this.selectedData.forEach(item => {
      t.push(item.id)
    })
    this.upParams.id = t.join(',')
  }
  // handleDownAll() {
  //   this.isAllDown = true
  //   this.getDownReasonList()
  //   this.getDownStatusList()
  //   this.downFormVisible = true
  //   let t: number[] = []
  //   this.selectedData.forEach(item => {
  //     t.push(item.id)
  //   })
  //   this.downParams.id = t.join(',')
  // }
  handleMarkAll() {
    let t: number[] = []
    this.selectedData.forEach(item => {
      t.push(item.id)
    })
    let ids = t.join(',')
    this.markAppAndroid(ids)
  }
  goToDetail(item: IUpedRes) {
    this.routeQuery.id = item.id
    this.openWindow({
      name: 'AppDetail',
      query: this.routeQuery
    })
  }
  distributeApp(item: IUpedRes) {
    this.distributeVisible = true
    this.distributeParams.id = (item.id).toString()
  }
  handleFormClose() {
    this.resetChannelList()
    this.isAllDown = false
  }
  resetChannelList() {
    this.channelList.forEach(item => {
      item.disabled = false
    })
  }
  async putApp(item: IUpedRes) {
    this.upFormVisible = true
    let { channelList: hasSelectedChannelList } = await this.getAndroidAppChannelList(item.id)
    this.channelList.forEach(item => {
      if (hasSelectedChannelList.includes(item.id)) {
        item.disabled = true
      }
    })
    this.upParams.id = (item.id).toString()
  }
  async downApp(item: IUpedRes) {
    this.downFormVisible = true
    this.downParams.channel = []
    this.downParams.type = this.downParams.reason = this.downParams.detail = ''
    let res: any = await getAndroidAppChannelList({ id: item.id })
    let hasSelectedChannelList: any = res.data.dataList.channelList
    console.log(hasSelectedChannelList)
    let newList: any = []
    this.channelList.forEach((item: any) => {
      if (hasSelectedChannelList.includes(item.id)) {
        newList.push(item)
      }
    })
    this.channelList = newList
    this.$nextTick(() => {
      (this.$refs['downParams'] as Form).resetFields()
      this.downParams.id = (item.id).toString()
    })
  }
  // TODO: 缺少接口
  markApp(item: IUpedRes) {
    let id = item.id.toString()
    this.markAppAndroid(id)
  }
  cancelUpForm() {
    (this.$refs['upParams'] as Form).resetFields()
    this.upParams.endDate = ''
    this.upFormVisible = false
  }
  confirmUpForm() {
    (this.$refs['upParams'] as Form).validate(valid => {
      if (valid) {
        let isDateValid = compareDate(this.upParams.startDate, this.upParams.endDate)
        isDateValid ? this.putUpAppAndroid() : this['$message'].error('上架结束时间必须大于上架开始时间')
      } else {
        this['$message'].error('请填写缺失参数!')
        return false
      }
    })
  }
  cancelDownForm() {
    (this.$refs['downParams'] as Form).resetFields()
    this.downParams.detail = ''
    this.downFormVisible = false
  }
  confirmDownForm() {
    (this.$refs['downParams'] as Form).validate(valid => {
      if (valid) {
        this.putDownAppAndroid()
      } else {
        this['$message'].error('请填写缺失参数!')
        return false
      }
    })
  }
  async selectAll(flag:boolean) {
    // flag为true表示上架全选,否则为下架全选
    let _list = [...this.channelList]
    let emptyList: any = []
    _list.forEach((item:any) => {
      emptyList.push(item.id)
    })
    if (flag) {
      this.upParams.channel = emptyList
    } else {
      // console.log(this.getIosAppChannelList(this.downParams.id))
      this.isAllDown = true
      this.downParams.channel = emptyList
    }
  }
  cancelDistributeForm() {
    (this.$refs['distributeParams'] as Form).resetFields()
    this.distributeVisible = false
  }
  confirmDistributeForm() {
    // TODO: 提交请求
    (this.$refs['distributeParams'] as Form).validate(valid => {
      if (valid) {
        alert('无接口!')
      } else {
        console.log('error submit!!')
        return false
      }
    })
  }
  // computed
  get showMultiSelect() {
    return this.selectedData.length > 1
  }
  get selectCount() {
    return this.selectedData.length
  }
  @Watch('downParams', { deep: true })
  onChannelChange(nv: any, ov: any) {
    console.log(nv)
    if (nv.channel.length === this.appChannelList.length) {
      this.showFormItem = true
    } else {
      this.showFormItem = false
    }
  }
}
